import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTimes, 
  faSpinner
} from '@fortawesome/free-solid-svg-icons';
import styles from '../ManagerDashboard/Profile.module.css';

// Disconnect confirmation modal
export const DisconnectConfirmModal = ({ isOpen, onClose, onConfirm, isLoading }) => {
  if (!isOpen) return null;
  
  return (
    <div className={styles['modal-overlay']}>
      <div className={styles['modal-content']}>
        <button className={styles['modal-close']} onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <h2>Remove Connection</h2>
        <p>Are you sure you want to remove this connection? This action cannot be undone.</p>
        
        <div className={styles['form-actions']}>
          <button 
            className={styles['secondary-button']} 
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button 
            className={styles['primary-button']}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Removing...' : 'Remove Connection'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Unrecommend confirmation modal
export const UnrecommendConfirmModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;
  
  return (
    <div className={styles['modal-overlay']}>
      <div className={styles['modal-content']}>
        <button className={styles['modal-close']} onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <h2>Remove Recommendation</h2>
        <p>Are you sure you want to remove your recommendation? This action cannot be undone.</p>
        
        <div className={styles['form-actions']}>
          <button 
            className={styles['secondary-button']} 
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className={styles['primary-button']}
            onClick={onConfirm}
          >
            Remove Recommendation
          </button>
        </div>
      </div>
    </div>
  );
};

// Cancel request confirmation modal
export const CancelRequestModal = ({ isOpen, onClose, onConfirm, isLoading }) => {
  if (!isOpen) return null;
  
  return (
    <div className={styles['modal-overlay']}>
      <div className={styles['modal-content']}>
        <button className={styles['modal-close']} onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <h2>Cancel Connection Request</h2>
        <p>Are you sure you want to cancel your connection request?</p>
        
        <div className={styles['form-actions']}>
          <button 
            className={styles['secondary-button']} 
            onClick={onClose}
            disabled={isLoading}
          >
            No, Keep Request
          </button>
          <button 
            className={styles['primary-button']}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Cancelling...' : 'Yes, Cancel Request'}
          </button>
        </div>
      </div>
    </div>
  );
};